module.exports = __webpack_public_path__ + "img/microfono.b9d69f8a.gif";